export type TeamColorKey = "mobility" | "attack" | "defense"

export const TEAM_COLORS: Record<
  TeamColorKey,
  {
    accent: string
    card: string
    slot: string
    cardAccent: string
    beamFrom: string
    beamTo: string
  }
> = {
  mobility: {
    accent: "text-cyan-950 dark:text-cyan-100",
    card: "border-cyan-400/35! bg-[radial-gradient(circle_at_top_left,rgba(34,211,238,0.20),transparent_46%),linear-gradient(180deg,rgba(118,190,212,0.20),rgba(118,190,212,0.08)),linear-gradient(180deg,var(--surface-1),color-mix(in_oklch,var(--surface-2)_88%,var(--secondary)))]! shadow-[0_24px_44px_-32px_rgba(6,182,212,0.52)]!",
    slot: "border-cyan-400/45 bg-cyan-50/80 text-gray-900",
    cardAccent: "border-cyan-300/30 bg-cyan-500/10",
    beamFrom: "#22d3ee",
    beamTo: "#0891b2",
  },
  attack: {
    accent: "text-rose-950 dark:text-rose-100",
    card: "border-rose-400/35! bg-[radial-gradient(circle_at_top_left,rgba(251,113,133,0.21),transparent_46%),linear-gradient(180deg,rgba(245,126,144,0.22),rgba(245,126,144,0.08)),linear-gradient(180deg,var(--surface-1),color-mix(in_oklch,var(--surface-2)_88%,var(--secondary)))]! shadow-[0_24px_44px_-32px_rgba(244,63,94,0.48)]!",
    slot: "border-rose-400/45 bg-rose-50/80 text-gray-900",
    cardAccent: "border-rose-300/30 bg-rose-500/10",
    beamFrom: "#fb7185",
    beamTo: "#e11d48",
  },
  defense: {
    accent: "text-amber-950 dark:text-amber-100",
    card: "border-amber-400/35! bg-[radial-gradient(circle_at_top_left,rgba(251,191,36,0.20),transparent_46%),linear-gradient(180deg,rgba(250,204,21,0.20),rgba(250,204,21,0.08)),linear-gradient(180deg,var(--surface-1),color-mix(in_oklch,var(--surface-2)_88%,var(--secondary)))]! shadow-[0_24px_44px_-32px_rgba(217,119,6,0.46)]!",
    slot: "border-amber-400/45 bg-amber-50/85 text-gray-900",
    cardAccent: "border-amber-300/30 bg-amber-500/10",
    beamFrom: "#fbbf24",
    beamTo: "#d97706",
  },
} as const

export type SectionColorKey = "halftime" | "commanders"

export const SECTION_COLORS: Record<
  SectionColorKey,
  {
    card: string
    header: string
    title: string
    slot: string
  }
> = {
  halftime: {
    card: "border-emerald-300/35 bg-[linear-gradient(180deg,rgba(216,249,232,0.96),rgba(239,253,245,0.98))] shadow-[0_24px_40px_-30px_rgba(22,101,52,0.35)] dark:border-emerald-400/25 dark:bg-[linear-gradient(180deg,rgba(6,78,59,0.34),rgba(2,44,34,0.24))]",
    header:
      "border-b border-emerald-400/30 bg-[linear-gradient(180deg,rgba(5,46,22,0.82),rgba(6,78,59,0.72))]",
    title: "text-emerald-50",
    slot: "border-emerald-400/40 bg-white/90 text-gray-900 dark:border-emerald-400/25 dark:bg-emerald-950/35 dark:text-emerald-50",
  },
  commanders: {
    card: "border-fuchsia-300/30 bg-[linear-gradient(180deg,rgba(255,233,247,0.96),rgba(255,245,251,0.98))] shadow-[0_24px_40px_-30px_rgba(147,51,234,0.28)] dark:border-fuchsia-400/25 dark:bg-[linear-gradient(180deg,rgba(112,26,117,0.28),rgba(80,7,36,0.22))]",
    header:
      "border-b border-fuchsia-300/30 bg-[linear-gradient(180deg,rgba(80,7,36,0.84),rgba(112,26,117,0.74))]",
    title: "text-fuchsia-50",
    slot: "border-fuchsia-400/35 bg-white/90 text-gray-900 dark:border-fuchsia-400/25 dark:bg-fuchsia-950/30 dark:text-fuchsia-50",
  },
} as const

export const HERO_COLORS = {
  title: "text-cyan-100",
  exportButton:
    "border-cyan-200/45 bg-cyan-300/20 text-cyan-50 shadow-[0_12px_30px_-18px_rgba(125,211,252,0.95)] transition-all duration-150 hover:-translate-y-0.5 hover:bg-cyan-200/28 hover:shadow-[0_16px_34px_-16px_rgba(125,211,252,0.98)]",
} as const
